import React, { useContext } from 'react';
import BoxRow from './BoxRow';
import { TranslationContext } from "./Context";

function VehicleDetails(props) {

    const translation = useContext(TranslationContext);
    const vehicle = props.vehicle;

    function formatDate(input) {
        let result = "";

        if (input === 0) {
            return "";
        }

        const inputString = input.toString();
        if (inputString.length === 6) {
            result = `${inputString.substring(0, 4)}-${inputString.substring(4, 2)}`;
        }

        return result;
    }


    return (
        <div className="partsSearchResultComponent-box">
            <BoxRow title={translation["TecAlliencePartSearch.SearchResult.Details.ModelYearFrom"]} desc={formatDate(vehicle.yearOfConstrFrom) + ' - ' + formatDate(vehicle.yearOfConstrTo)} />
            <BoxRow title={translation["TecAlliencePartSearch.SearchResult.Details.Output"]} desc={vehicle.powerKwFrom + "KW/" + vehicle.powerHpFrom + "PS"} />
            <BoxRow title={translation["TecAlliencePartSearch.SearchResult.Details.EngingeCapacity"]} desc={vehicle.cylinderCapacityCcm} />
            <BoxRow title={translation["TecAlliencePartSearch.SearchResult.Details.ValvesPerCylinder"]} desc={vehicle.valves} />
            <BoxRow title={translation["TecAlliencePartSearch.SearchResult.Details.Cylinders"]} desc={vehicle.cylinder} />
            <BoxRow title={translation["TecAlliencePartSearch.SearchResult.Details.MotorType"]} desc={vehicle.motorType} />
        </div>);
}

export default VehicleDetails;